<template>
  <div class="account-page-container">
    <div class="account-page-main">
      <el-card class="account-page-body" v-loading="isLoading">
        <div slot="header">
          <el-form :inline="true" :model="reqParams" size="mini" label-width="120px" class="search-params-form">
            <el-form-item label="企业名称：">
              <el-input placeholder="请输入企业名称" v-model="reqParams.companyName" size="mini" clearable></el-input>
            </el-form-item>
            <el-form-item label="员工姓名：">
              <el-input placeholder="请输入员工姓名" v-model="reqParams.userName" size="mini" clearable></el-input>
            </el-form-item>
            <el-form-item label="联系方式：">
              <el-input placeholder="请输入手机号" v-model="reqParams.userPhone" size="mini" clearable></el-input>
            </el-form-item>
            <el-form-item label="账号状态：">
              <el-select v-model="reqParams.accountState" clearable>
                <el-option v-for="statu in UserStatusArray" :key="statu.value" :label="statu.label" :value="statu.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="账号性质：">
              <el-select v-model="reqParams.userType" clearable>
                <el-option v-for="utype in UserTypesArray" :key="utype.value" :label="utype.label" :value="utype.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=" ">
              <div class="search-button">
                <el-button type="primary" @click="onSearch">查询</el-button>
              </div>
              <el-button @click="onResetReqParams">重置</el-button>
            </el-form-item>
          </el-form>
        </div> <!-- end of header -->
        <div style="height:36px;line-height:36px;">
          <span style="color:#1a0fbe;font-size:14px;">提示：账号停用、注销后无法登陆小程序，账号停用后可以启用，启用后可以重新使用，账号注销后不能再启用只能重新注册。</span>
          <el-button type="primary" class="fr" size="small" style="height:28px;margin-top:5px;" @click="showAddAccountDialog">开通账号</el-button>
        </div>
        <div class="account-card-body">
          <div class="table-container">
            <el-table :data="staffInfoList" ref="configurationTable" border style="width: 100%" stripe size="mini" height="100%">
              <el-table-column label="公司名称" min-width="100" align="center" property="userCompanyName"></el-table-column>
              <el-table-column label="员工姓名" min-width="100" align="center" property="userName"></el-table-column>
              <el-table-column label="联系方式" min-width="140" align="center" property="userPhone"></el-table-column>
              <el-table-column label="老板姓名" min-width="100" align="center" property="bossName"></el-table-column>
              <el-table-column label="老板电话" min-width="100" align="center" property="bossPhone"></el-table-column>
              <el-table-column label="账号状态" width="100" align="center" property="accountStateSummary"></el-table-column>
              <el-table-column label="停用/注销原因" min-width="200" align="center" property="unavailableReason"></el-table-column>

              <el-table-column label="操作" align="center" min-width="100">
                <template slot-scope="scope">
                  <div style="display:inline-block;margin-right: 10px;">
                    <el-button @click="showSuspendAccountDialog(scope.row)" type="text" size="mini" :disabled="!scope.row.ableSuspend" v-if="scope.row.accountState !== 2">停用</el-button>
                    <el-button @click="enableAccountOnClick(scope.row)" type="text" size="mini" v-else>启用</el-button>
                  </div>
                  <el-button @click="showCloseAccountDialog(scope.row)" type="text" size="mini" :disabled="!scope.row.ableClose">注销</el-button>
                  <el-button @click="beforeAuthorizeDialog(scope.row)" type="text" size="mini" :disabled="(!scope.row.ableSuspend)||(!scope.row.ableClose)">授权</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="footer">
          <el-pagination
            background
            small
            @current-change="onChangePager"
            :current-page="reqParams.page"
            :page-size="reqParams.perPage"
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>
        </div>
      </el-card>
      <div class="dialog-container">
        <el-dialog :visible.sync="addAccountDialogVisible"
                   width="40%"
                   :show-close="true"
                   :before-close="onAddAccountDialogClose"
                   :close-on-click-modal="false"
                   center>
          <div class="dialog-main">
            <el-form :model="newAcountParams" label-width="110px" class="search-params-form" ref="addAccountForm" :rules="addAccountRules">
              <el-form-item label="用户姓名：" prop="userName">
                <el-input placeholder="请输入用户姓名" v-model="newAcountParams.userName" size="mini" clearable style="width:85%"></el-input>
              </el-form-item>
              <el-form-item label="用户电话：" prop="userPhone">
                <el-input placeholder="请输入用户手机号" v-model="newAcountParams.userPhone" size="mini" clearable style="width:85%"></el-input>
              </el-form-item>
              <el-form-item label="老板电话：" prop="bossPhone">
                <el-input placeholder="仅用于开通员工账号时，输入老板手机号" v-model="newAcountParams.bossPhone" size="mini" clearable style="width:85%"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="addingAccount('agentBoss')" type="primary">开通经销商老板账号</el-button>
            <el-button @click="addingAccount('farmerBoss')" type="primary">开通薯农老板账号</el-button>
            <el-button @click="addingAccount('staff')" type="primary">开通员工账号</el-button>
          </div>
        </el-dialog>
      </div>
      <div class="dialog-container">
        <el-dialog :visible.sync="changeAccountStateDialogVisible"
                   width="30%"
                   :show-close="true"
                   :before-close="onChangeAccountStateDialogClose"
                   :close-on-click-modal="false"
                   center>
          <div slot="title" style="font-size:14px;text-align:left;color:#1a0fbe;width:97%;">提示：账号停用、注销后无法登陆小程序，账号停用后可以启用，启用后可以重新使用，账号注销后不允许再启用。</div>
          <div class="dialog-main">
            <el-form :model="changeAccountStateParams" label-width="110px" class="search-params-form" ref="changeAccountForm" :rules="changeAccountStateRules">
              <el-form-item :label="changeAccountStateLabel" prop="unavailableReason">
                <el-input :placeholder="'请输入' + changeAccountStateLabel"
                          maxlength="50"
                          :rows="4"
                          show-word-limit
                          v-model="changeAccountStateParams.unavailableReason"
                          style="width:95%;"
                          resize="none"
                          type="textarea"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer">
            <el-button @click="changeAccountStateConfirm" type="primary">确定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { postRequest, putRequest, getRequest } from 'utils/http-service'
import { URL_ACCOUNT } from '../../constants/url'
import { UserStatusEnum } from '../../utils/UserStatusEnum'
import { UserTypesEnum } from '../../utils/UserTypesEnum'
import { fetchBossOfCompany } from '../../utils/CommonAPIs'

export default {
  name: 'account',
  data () {
    let checkReason = (rule, value, callback) => {
      if (!value) {
        let text = '注销'

        if (this.changeAccountStateParams.accountState === 2) {
          text = '停用'
        }

        return callback(new Error(`请输入${text}原因!`))
      }
      callback()
    }
    return {
      reqParams: {
        companyName: '',
        userName: '',
        userPhone: '',
        accountState: '',
        userType: '',
        page: 1,
        perPage: 10
      },
      newAcountParams: {
        userName: '',
        userPhone: '',
        bossPhone: ''
      },
      addAccountRules: {
        userName: [
          { required: true, message: '请输入用户姓名!', trigger: 'blur' },
          { min: 2, message: '用户姓名至少2个字符', trigger: 'blur' }
        ],
        userPhone: [
          { required: true, message: '请输入用户手机号!', trigger: 'blur' },
          { min: 11, max: 11, message: '用户电话必须填写11位手机号!', trigger: 'blur' }
        ]
      },
      changeAccountStateParams: {
        userID: '',
        accountState: '',
        unavailableReason: ''
      },
      changeAccountStateRules: {
        unavailableReason: [
          { validator: checkReason, trigger: 'blur' }
        ]
      },
      staffInfoList: [],
      UserStatusArray: [],
      UserTypesArray: [],
      isLoading: false,
      total: 0,
      addAccountDialogVisible: false,
      changeAccountStateDialogVisible: false,
      changeAccountStateLabel: ''
    }
  },

  methods: {
    getStaffInfoList () {
      this.isLoading = true
      let reqParams = this.reqParams
      let params = {
        orgName: reqParams.companyName,
        userName: reqParams.userName,
        phoneNumber: reqParams.userPhone,
        accountState: reqParams.accountState,
        userType: reqParams.userType,
        pageNumber: reqParams.page,
        pageSize: reqParams.perPage
      }

      getRequest(URL_ACCOUNT, params)
        .then(res => {
          if (res.code !== 0) {
            this.isLoading = false
            console.error(this.$route.name + 'getStaffInfoList() res', res)
            this.$message({ message: res.message || '服务器异常，请稍后重试！', showClose: true, offset: 300, type: 'error' })
            return
          }

          let dataList = []
          try {
            dataList = this._convertDto2Vo(res.data.pageData)
          } catch (error) {
            console.error(this.$route.name + '_convertDto2Vo() err', error)
          }

          if (!Array.isArray(dataList) || dataList.length === 0) {
            this.isLoading = false
            this.$message({
              showClose: true,
              message: '当前没有任何信息！',
              offset: 300,
              type: 'warning'
            })
            console.error(this.$route.name + ' getStaffInfoList() err: 当前没有任何信息！')
            this.staffInfoList = []
            this.total = 0
            return
          }

          this.staffInfoList = dataList
          this.total = res.data.totalRecordCount
          this.isLoading = false

          // 查询老板信息
          let companyIDs = []
          this.staffInfoList.forEach(staff => {
            companyIDs.push(staff.userCompanyID)
          })
          this._fetchBossOfCompany(companyIDs.toString())
        })
        .catch(err => {
          this.isLoading = false
          console.error(this.$route.name + ' getStaffInfoList() err', err)
          this.$message({ message: err.message || '服务器异常，请稍后重试！', showClose: true, offset: 300, type: 'error' })
        })
    },

    _convertDto2Vo (dataList) {
      let vo = []

      dataList.forEach((item) => {
        let voItem = {
          userCompanyName: item.userCompanyName,
          userCompanyID: item.userCompanyID,
          userID: item.userID,
          userName: item.userName,
          userPhone: !item.phone ? '' : item.phone.replace(',', ''),
          accountState: item.accoutState,
          userType: item.userType,
          accountStateSummary: (item.accoutState || item.accoutState === 0) ? UserStatusEnum.getEnumByValue(Number(item.accoutState)).summaryCN : '',
          userTypeSummary: (item.userType || item.userType === 0) ? UserTypesEnum.getEnumByValue(Number(item.userType)).summaryCN : '',
          unavailableReason: item.unavailableReason,
          bossID: '',
          bossName: '',
          bossPhone: ''
        }

        voItem.ableClose = voItem.accountState !== UserStatusEnum.CANCELLED.value
        voItem.ableSuspend = voItem.accountState === UserStatusEnum.AVAILABLE.value
        vo.push(voItem)
      })

      return vo
    },

    _fetchBossOfCompany (companyIDs) {
      let that = this

      fetchBossOfCompany(that, { companyIDs: companyIDs }, {
        onSucc (companyID2BossMap) {
          console.log(that.$route.name + ' _fetchBossOfCompany() res', companyID2BossMap)

          // 给每个人员补充老板信息
          let companyID2Staff = {}
          for (let i = 0; i < that.staffInfoList.length; i++) {
            let staff = that.staffInfoList[i]
            if (!companyID2Staff[staff.userCompanyID]) {
              companyID2Staff[staff.userCompanyID] = []
            }
            companyID2Staff[staff.userCompanyID].push(staff)
          }

          (Object.keys(companyID2BossMap) || []).forEach(companyID => {
            let boss = companyID2BossMap[companyID];
            (companyID2Staff[companyID] || []).forEach(staff => {
              staff.bossID = boss.id
              staff.bossName = boss.name
              staff.bossPhone = boss.phone + (boss.secondaryPhone ? ', ' + boss.secondaryPhone : '')
            })
          })

          for (let i = 0; i < that.staffInfoList.length; i++) {
            that.$set(that.staffInfoList, i, that.staffInfoList[i])
          }
        },

        onFail (errMsg) {
          that.$message({ message: errMsg || '查询老板信息异常，请稍后重试！', showClose: true, offset: 300, type: 'error' })
        }
      })
    }, // end of _fetchBossOfCompany

    onSearch () {
      this.reqParams.page = 1
      this.getStaffInfoList()
    },

    onResetReqParams () {
      this.reqParams = {
        companyName: '',
        userName: '',
        userPhone: '',
        accountState: '',
        userType: '',
        page: 1,
        perPage: 10
      }

      this.getStaffInfoList()
    },

    onChangePager (newPage) {
      this.reqParams.page = newPage
      this.getStaffInfoList()
    },

    showAddAccountDialog () {
      this.addAccountDialogVisible = true
    },

    onAddAccountDialogClose () {
      this.$refs.addAccountForm.clearValidate()
      this.addAccountDialogVisible = false
    },

    addingAccount (accountType) { // agentBoss - 经销商老板; farmerBoss - 薯农老板; staff - 员工账号
      this.$refs.addAccountForm.validate((valid) => {
        if (!valid) {
          return
        }

        if (accountType === 'staff') {
          if (!this.newAcountParams.bossPhone || this.newAcountParams.bossPhone.length !== 11) {
            this.$message({ message: '开通员工账号必须正确填写其老板的手机号', showClose: true, offset: 300, type: 'error' })
            return
          }

          this.$confirm('确定开通员工账号？', '提示', {
            confirmButtonText: '确定',
            type: 'warning'
          })
            .then(() => {
              this._doAddingAccount(accountType)
            })
            .catch(ignore => {})

          return
        }

        this._doAddingAccount(accountType)
      })
    },

    _doAddingAccount (accountType) {
      console.log(this.$route.name + '_doAddingAccount()', this.newAcountParams)
      this.isLoading = true
      let text = '未知类型'
      if (accountType === 'agentBoss') {
        text = '经销商老板'
      } else if (accountType === 'farmerBoss') {
        text = '薯农老板'
      } else if (accountType === 'staff') {
        text = '员工'
      }

      let bossPhone = this.newAcountParams.bossPhone
      let params = {
        userName: this.newAcountParams.userName.trim(),
        userPhone: this.newAcountParams.userPhone.trim(),
        accountType: accountType,
        bossPhone: bossPhone ? bossPhone.trim() : bossPhone
      }
      console.log('add account params', params)

      postRequest(URL_ACCOUNT, params)
        .then(res => {
          this.isLoading = false
          if (res.code !== 0) {
            this.$message({ message: (res.message && `${text}账号开通失败！${res.message}`) || `${text}账号开通失败！`, showClose: true, offset: 300, type: 'error' })
            return
          }

          this.$message({ message: `${text}账号开通成功`, showClose: true, offset: 300, type: 'success' })
          this.clearNewAcountParams()
          this.onAddAccountDialogClose()
          this.getStaffInfoList()
        })
        .catch(err => {
          this.isLoading = false
          console.error(this.$route.name + ' _doAddingAccount() err', err)
          this.$message({ message: err.message || '服务器异常，请稍后重试！', showClose: true, offset: 300, type: 'error' })
        })
    },

    clearNewAcountParams () {
      this.newAcountParams = {
        userName: '',
        userPhone: '',
        bossPhone: ''
      }
    },

    showSuspendAccountDialog (row) {
      this.$confirm('账号停用后将不能登录小程序，您确定停用用户账号 ' + row.userName + ' 吗？', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      })
        .then(() => {
          this.changeAccountStateParams.userID = row.userID
          this.changeAccountStateParams.accountState = UserStatusEnum.DISABLE.value
          this.changeAccountStateLabel = '停用原因'
          this.changeAccountStateDialogVisible = true
        })
        .catch(ignore => {})
    },

    showCloseAccountDialog (row) {
      this.$confirm('账号注销后将不能登录小程序，同时该账号下关联的数据将同时注销，您确定注销账号 ' + row.userName + ' 吗？', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      })
        .then(() => {
          this.changeAccountStateParams.userID = row.userID
          this.changeAccountStateParams.accountState = UserStatusEnum.CANCELLED.value
          this.changeAccountStateLabel = '注销原因'
          this.changeAccountStateDialogVisible = true
        })
        .catch(ignore => {})
    },

    enableAccountOnClick (row) {
      this.$confirm('账号启用后即可正常登录小程序，您确定启用账号 ' + row.userName + ' 吗？', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      })
        .then(() => {
          this.isLoading = true
          putRequest(URL_ACCOUNT, {
            userID: row.userID,
            operation: UserStatusEnum.AVAILABLE.value
          })
            .then(res => {
              this.isLoading = false
              if (res.code !== 0) {
                this.$message({ message: (res.message && `账号启用失败！${res.message}`) || `账号启用失败！`, showClose: true, offset: 300, type: 'error' })
                return
              }
              this.$message({ message: `账号启用成功，`, showClose: true, offset: 300, type: 'success' })
              this.getStaffInfoList()
            })
            .catch(err => {
              this.isLoading = false
              console.error(this.$route.name + ' enableAccountOnClick() err', err)
              this.$message({ message: err.message || '服务器异常，请稍后重试！', showClose: true, offset: 300, type: 'error' })
            })
        })
        .catch(ignore => {})
    },

    beforeAuthorizeDialog (row) {
      if (!row.userName) {
        this.$alert('没有员工姓名', '提示', {
          confirmButtonText: '确定'
        })
      } else if (!row.userPhone) {
        this.$alert('没有联系方式', '标题名称', {
          confirmButtonText: '确定'
        })
      } else {
        this.$router.push({
          name: 'staff-role-list',
          params: {
            userName: row.userName,
            userPhone: row.userPhone
          }
        })
      }
      // this.$router.push({path: '/staff-role-list', name: 'userName', params: { userId: row.userName }})
    },

    onChangeAccountStateDialogClose () {
      this.changeAccountStateParams = {
        userID: '',
        accountState: '',
        unavailableReason: ''
      }
      this.$refs.changeAccountForm.clearValidate()
      this.changeAccountStateDialogVisible = false
    },

    changeAccountStateConfirm () {
      let text = this.changeAccountStateParams.accountState === UserStatusEnum.CANCELLED.value ? '注销' : '停用'

      this.$refs.changeAccountForm.validate((valid) => {
        if (valid) {
          this.isLoading = true
          putRequest(URL_ACCOUNT, {
            userID: this.changeAccountStateParams.userID,
            operation: this.changeAccountStateParams.accountState,
            reason: this.changeAccountStateParams.unavailableReason
          })
            .then(res => {
              this.isLoading = false
              if (res.code !== 0) {
                this.$message({ message: (res.message && `账号${text}失败！${res.message}`) || `账号${text}失败！`, showClose: true, offset: 300, type: 'error' })
                return
              }
              this.$message({ message: `账号${text}成功，`, showClose: true, offset: 300, type: 'success' })
              this.onChangeAccountStateDialogClose()
              this.getStaffInfoList()
            })
            .catch(err => {
              this.isLoading = false
              console.error(this.$route.name + ' changeAccountStateConfirm() err', err)
              this.$message({ message: err.message || '服务器异常，请稍后重试！', showClose: true, offset: 300, type: 'error' })
            })
        }
      })
    }
  },

  created () {
    let UserStatusArray = []
    let UserStatusEnumArray = UserStatusEnum.symbols()

    let UserTypesArray = []
    let UserTypesEnumArray = UserTypesEnum.symbols()

    UserStatusEnumArray.forEach(item => {
      UserStatusArray.push({value: item.value, label: item.summaryCN})
    })

    UserTypesEnumArray.forEach(item => {
      UserTypesArray.push({value: item.value, label: item.summaryCN})
    })

    this.UserStatusArray = UserStatusArray
    UserTypesArray.push({value: '', label: '所有用户'})
    this.UserTypesArray = UserTypesArray
    this.getStaffInfoList()
  }
}
</script>

<style lang="less" scoped>
.account-page-container {
  display: flex;
  flex-direction: column;
  width:100%;
  height:100%;
  padding: 15px 20px;
  .account-page-main {
    flex: 1;
    width:100%;
    height:100%;
    .account-page-body {
      display: flex;
      flex-direction: column;
      width:100%;
      height:100%;
      overflow-y: auto;
      /deep/ .el-card__header {
        padding: 14px 20px 4px;
        background-color: #fff;
      }
      /deep/ .el-card__body {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        flex: 1;
        min-height: 280px;
        padding-top: 0;
        padding-bottom: 10px;
      }
      .search-params-form {
        width: 100%;
        height: 100%;
        .search-button {
          display: inline-block;
          margin-right: 70px;
        }
      }
      .account-card-body {
        width: 100%;
        height: 100%;
        flex: 1;
        .table-container {
          height: 100%;
        }
      }
      .footer {
        display: flex;
        justify-content: flex-end;
        height: 25px;
        margin-top: 15px;
      }
    }
    .dialog-container {
      .dialog-main {
        .search-params-form {
          .no-bottom-form-item {
            margin-bottom: 0;
          }
        }
      }
      .dialog-footer {
        display: flex;
        justify-content: space-around;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/account/index.vue